import React from 'react';
import clsx from 'clsx';
import { useSummaryColStyles } from './styles';
const SummaryCol = ({ children, isStacked, isHidden, dynamicStyle }) => {
    const ownClasses = useSummaryColStyles({ isHidden, dynamicStyle });
    return React.createElement("div", { className: clsx(ownClasses.root, { [ownClasses.stacked]: isStacked }) }, children);
};
export default SummaryCol;
